import styled, { css } from 'styled-components';
import { device } from './variables';

const fullScreen = css`
  display: flex;
  height: 100vh;
  width: 100vw;
`;

const centeredFullScreen = css`
  ${fullScreen}
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const centeredFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;


const LoaderDiv = styled.div`
  transform: translate(0, 504px);
  @media ${device.md} {
    transform: translate(0, 482px);
  }
`;


export { centeredFullScreen, centeredFlex, fullScreen, LoaderDiv };
